
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        carrierName: {
            type: String,
            default: null,
        },
        carBrand: {
            type: String,
            default: null,
        },
        cubature: {
            type: String,
            default: null,
        },
        loadingType: {
            type: String,
            default: null,
        },
        carInfo: {
            type: Object,
            default: null,
        },
        cargoName: {
            type: String,
            default: null,
        },
        carNumber: {
            type: String,
            default: null,
        },
        driverName: {
            type: String,
            default: null,
        },
        driverPhone: {
            type: String,
            default: null,
        },
        loadCapacity: {
            type: String,
            default: null,
        },
        oversizedCargo: {
            type: String,
            default: null,
        },
        trailerLicenseNumber: {
            type: String,
            default: null,
        },
        autoDuration: {
            type: Number,
            default: null,
        },
        logistBidId: {
            type: Number,
            default: null,
        },
    },
})
